"use strict";
import $ from "jquery";
import _ from "underscore";
import ApiService from "../services/api_service";
import ObjectWithIDStore from "../stores/object_with_id_store";
var ContactService = function() {
  var deferred = $.Deferred();
  var store = new ObjectWithIDStore();
  var unknownContact = {
    id: "",
    name: "Unknown Contact",
    email: ""
  };
  var self = this;
  function clean(name) {
    if (_.isNull(name)) {
      name = "";
    }
    return name.toLowerCase().replace(/[& -]/g, "");
  }
  this.contactService = {
    store,
    contacts: function() {
      return _.sortBy(store.items, this.contactSort);
    },
    getContact: function(id) {
      return store.index[id];
    },
    contactWithId: function(contactId) {
      return store.index[contactId] || unknownContact;
    },
    searchByName: function(name) {
      return this.filterByName(name).slice(0, 20);
    },
    filterByEmailOrName: function(term) {
      return _.select(_.sortBy(store.items, this.contactSort), function(x) {
        return clean(x.name).indexOf(clean(term)) >= 0 || clean(x.email).indexOf(clean(term)) >= 0;
      });
    },
    contactSort: function(contact) {
      if (contact.id === "") {
        return "A";
      } else {
        return contact.email;
      }
    },
    updateContact: function(contact) {
      store.addOrUpdate(contact);
      $(this).trigger("contact_service:updated");
      return contact;
    },
    destroyContact: function(contact) {
      store.destroy(contact);
      $(this).trigger("contact_service:updated");
      return contact;
    }
  };
  function fetchAndStoreDataSince(date) {
    return ApiService.addErrorHandler(
      // @ts-expect-error - TODO: fix TypeScript error
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.get("/api/contacts?since=" + date.getTime()).success(function(data) {
        if (data.contacts.length > 0) {
          _.each(data.contacts, function(item) {
            store.addOrUpdate(item);
          });
        }
      }),
      "Failed to load contacts. Please refresh.",
      { caller: "ContactService.fetchAndStoreDataSince" }
    );
  }
  function loadContacts(deferred2) {
    fetchAndStoreDataSince(/* @__PURE__ */ new Date(0)).then(function() {
      deferred2.resolve(self.contactService);
    });
  }
  this.ready = _.once(function() {
    loadContacts(deferred);
    return deferred.promise();
  });
};
var contactService = new ContactService();
export default contactService;
